var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDigishopRing = function SvgDigishopRing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 196.44 195.57"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "digishop-ring_svg__a",
    x1: 157.23,
    x2: 41.67,
    y1: 19.53,
    y2: 146.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4691ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254e6e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#digishop-ring_svg__a",
    id: "digishop-ring_svg__b",
    x1: 140.69,
    x2: 53.74,
    y1: 84.15,
    y2: 179.68
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#digishop-ring_svg__a",
    id: "digishop-ring_svg__c",
    x1: 4150.08,
    x2: 4034.53,
    y1: -3542.26,
    y2: -3415.3,
    gradientTransform: "matrix(-.5 -.87 .87 -.5 5172.13 1891.8)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#digishop-ring_svg__a",
    id: "digishop-ring_svg__d",
    x1: 4133.55,
    x2: 4046.6,
    y1: -3510.1,
    y2: -3414.57,
    gradientTransform: "rotate(-120 3132.153 -547.11)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#digishop-ring_svg__a",
    id: "digishop-ring_svg__e",
    x1: 5259.21,
    x2: 5143.65,
    y1: 1647.78,
    y2: 1774.74,
    gradientTransform: "matrix(-.5 .87 -.88 -.51 4218.11 -3546.09)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#digishop-ring_svg__a",
    id: "digishop-ring_svg__f",
    x1: 5249.83,
    x2: 5162.88,
    y1: 1744.94,
    y2: 1840.47,
    gradientTransform: "rotate(120 3132.15 -547.113)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#digishop-ring_svg__a)",
    d: "M98.15 25.28A97.53 97.53 0 0 1 194.71 110 97.38 97.38 0 1 0 .77 97.38 100 100 0 0 0 1.59 110a97.53 97.53 0 0 1 96.56-84.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#digishop-ring_svg__b)",
    d: "M170.25 122.66a72 72 0 0 0-1.14-12.66 72.07 72.07 0 0 1-141.92 0 72.09 72.09 0 1 0 143.06 12.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#digishop-ring_svg__c)",
    d: "M35 133.82C10.32 91 22.19 36.92 60.82 7.44a97.5 97.5 0 0 0-11.46 5.67c-46.94 27.1-63.29 87-36.44 133.47s86.88 62.29 133.82 35.19a101 101 0 0 0 10.64-7.09c-44.85 18.71-97.65 1.93-122.38-40.86"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#digishop-ring_svg__d)",
    d: "M84 22.3a72.5 72.5 0 0 0-10.38 7.3 72.08 72.08 0 0 1 71 122.91A72.09 72.09 0 1 0 84 22.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#digishop-ring_svg__e)",
    d: "M161.31 134.18c-24.78 42.92-77.72 59.75-122.67 41a99 99 0 0 0 10.66 7.1c47.06 27.17 107.24 11.33 134.17-35.28S194 40.29 147 13.12a98 98 0 0 0-11.49-5.68c38.69 29.56 50.58 83.82 25.8 126.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#digishop-ring_svg__f)",
    d: "M40.21 147.17a72 72 0 0 0 11.51 5.34 72.08 72.08 0 0 1 71-122.91 72.09 72.09 0 1 0-82.51 117.57"
  }))));
};
export default SvgDigishopRing;